import React, { useEffect, useState } from "react";
import "./SubtotalHeader.css";

const SubtotalHeader: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    // Check if there's an existing timer in localStorage
    const endTime = localStorage.getItem("countdownEndTime");

    if (!endTime) {
      // If no timer exists, set a new 10-minute timer
      const newEndTime = Date.now() + 10 * 60 * 1000; // 10 minutes in milliseconds
      localStorage.setItem("countdownEndTime", newEndTime.toString());
    }

    const timer = setInterval(() => {
      const endTimeMs = parseInt(
        localStorage.getItem("countdownEndTime") || "0"
      );
      const now = Date.now();
      const timeRemaining = Math.max(0, endTimeMs - now);

      if (timeRemaining === 0) {
        // Timer has expired
        localStorage.removeItem("countdownEndTime");
        clearInterval(timer);
      }

      setTimeLeft(timeRemaining);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Convert milliseconds to minutes and seconds
  const minutes = Math.floor(timeLeft / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  // If timer is expired, don't render anything
  if (timeLeft === 0) return null;

  return (
    <div className="subtotal-header-parent">
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.8; }
            100% { opacity: 1; }
          }
        `}
      </style>
      <div className="subtotal-header-child">
        <div className="subtotal-text">
          ⏰ Your cart is reserved for{" "}
          <div
            className="countdown-timer"
            style={{
              backgroundColor: "rgba(255,255,255,0.2)",
              padding: "2px 6px",
              borderRadius: "4px",
              textAlign: "center",
              display: "inline-block",
              margin: "0 2px",
            }}
          >
            {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
          </div>{" "}
          mins! Grab the deal now!
        </div>
      </div>
    </div>
  );
};

export default SubtotalHeader;
